import { useLingui } from '@lingui/react/macro'
import { Button } from 'designSystem/components/Button'
import { Text } from 'designSystem/components/Text'
import { X } from 'lucide-react'
import React from 'react'
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch'
import styled from 'styled-components'

import type { ImagePreview } from './previewDocumentHandler'

const PanelRoot = styled.div`
  display: flex;
  height: 100%;
  min-height: 0;
  flex-direction: column;
`

const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border-bottom: 0.0625rem solid var(--border);
`

const ImageArea = styled.div`
  flex: 1;
  min-height: 0;
  background: ${({ theme }) => theme.forecast.pageBackground1};

  .react-transform-wrapper,
  .react-transform-component {
    width: 100%;
    height: 100%;
  }
`

const PreviewImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
`

export function ImagePreviewPanel({
  image,
  onClose,
}: {
  image: ImagePreview
  onClose: () => void
}): React.ReactElement {
  const { t } = useLingui()
  return (
    <PanelRoot>
      <PanelHeader>
        <Text as='span' variant='body' title={image.name}>
          {image.name}
        </Text>
        <Button
          variant='ghost'
          size='icon-sm'
          type='button'
          aria-label={t`Close image preview`}
          onClick={onClose}>
          <X size={16} />
        </Button>
      </PanelHeader>
      <ImageArea>
        <TransformWrapper centerOnInit doubleClick={{ mode: 'reset' }}>
          <TransformComponent>
            <PreviewImage src={image.previewUrl} alt={image.name} />
          </TransformComponent>
        </TransformWrapper>
      </ImageArea>
    </PanelRoot>
  )
}
